import { BaseEntity } from 'src/app/entities/base-entity/base-entity';

/**
 * Class that represents a person in the tracking system.
 *
 * For example an author, a member of a project, etc.
 *
 * @class Person
 */
export class Person extends BaseEntity {
  /**
   * Creates an instance of Person.
   *
   * @param {string} _uuid
   *   A unique identifier for the person.
   * @param {string} _name
   *   Person's name.
   */
  constructor(
    _uuid: string,
    protected _name: string,
  ) {
    super(_uuid);
  }

  get name(): string {
    return this._name;
  }
}
